var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.69642 15.7148H3.37053C3.48437 15.7148 3.59151 15.659 3.65848 15.5675L10 6.82645L16.3415 15.5675C16.4085 15.659 16.5156 15.7148 16.6295 15.7148H18.3036C18.4487 15.7148 18.5335 15.5497 18.4487 15.4314L10.5781 4.58092C10.2924 4.18806 9.70759 4.18806 9.4241 4.58092L1.55356 15.4314C1.46651 15.5497 1.55133 15.7148 1.69642 15.7148Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftIcon);
export default __webpack_public_path__ + "static/media/left-icon.6ebc067f4cd08d89cbf1f4aa6f819ab3.svg";
export { ForwardRef as ReactComponent };